import React, { FC } from 'react';

export const KSCIcon: FC<{ size: number; fill?: string }> = ({ size, fill = '#5d5d5f' }) => (
    <svg
        fill="none"
        height={size}
        viewBox="0 0 64 64"
        width={size}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_12194_71992)">
            <g clipPath="url(#clip1_12194_71992)">
                <path
                    clipRule="evenodd"
                    d="M56.748 16.725l-23-13.255a3.5 3.5 0 00-3.495 0l-23 13.255A3.5 3.5 0 005.5 19.758v24.489a3.5 3.5 0 001.752 3.032l23 13.255a3.5 3.5 0 003.496 0l23-13.255a3.5 3.5 0 001.752-3.032v-24.49a3.5 3.5 0 00-1.752-3.032zM35.245.87a6.5 6.5 0 00-6.49 0l-23 13.255A6.5 6.5 0 002.5 19.758v24.489a6.5 6.5 0 003.255 5.632l23 13.255a6.5 6.5 0 006.49 0l23-13.255a6.5 6.5 0 003.255-5.632v-24.49a6.5 6.5 0 00-3.255-5.632L35.245.87z"
                    fill="#29CCB1"
                    fillRule="evenodd"
                />
            </g>
            <path
                d="M26.49 37.79v5.745a.465.465 0 01-.93 0V37.79h-.46a.93.93 0 010-1.86h1.81a.93.93 0 010 1.86h-.42zM38.44 37.07v-.605a.465.465 0 00-.93 0v.605h-.41a.93.93 0 000 1.86h.41v4.605a.465.465 0 10.93 0V38.93h.47a.93.93 0 000-1.86h-.47zM32.44 36.465v3.605h.47a.93.93 0 010 1.86h-.47v1.605a.465.465 0 01-.93 0V41.93h-.41a.93.93 0 010-1.86h.41v-3.605a.465.465 0 11.93 0z"
                fill={fill}
            />
            <path
                clipRule="evenodd"
                d="M27.2 18.999C29.073 16.569 31.978 15 35.25 15c5.363 0 9.729 4.206 10.207 9.529a8.503 8.503 0 01-1.597 16.363v5.598a1.5 1.5 0 01-1.5 1.5H21.63a1.5 1.5 0 01-1.5-1.5v-5.64a8.752 8.752 0 01-1.598-16.74A6.25 6.25 0 0127.2 19zM49 32.5a6.503 6.503 0 01-5.14 6.358V31.35a1.5 1.5 0 00-1.5-1.5H21.63a1.5 1.5 0 00-1.5 1.5v7.454a6.753 6.753 0 01-.34-13.015 1 1 0 00.71-.973v-.066a4.25 4.25 0 016.488-3.614 1 1 0 001.37-.31C29.84 18.512 32.378 17 35.25 17c4.465 0 8.14 3.67 8.248 8.292a1 1 0 00.734.94A6.503 6.503 0 0149 32.5zM22.04 46.08V33.85h19.93v12.23H22.04z"
                fill={fill}
                fillRule="evenodd"
            />
        </g>
        <defs>
            <clipPath id="clip0_12194_71992">
                <path d="M0 0H64V64H0z" fill="#fff" />
            </clipPath>
            <clipPath id="clip1_12194_71992">
                <path d="M0 0H64V64H0z" fill="#fff" />
            </clipPath>
        </defs>
    </svg>
);
